/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_Translate_Offer_ActionInputs */

const cs_blog_ai_translate_offer_action = /** @type {(inputs: Blog_Ai_Translate_Offer_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeložit`)
};

const en_blog_ai_translate_offer_action = /** @type {(inputs: Blog_Ai_Translate_Offer_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate now`)
};

/**
* | output |
* | --- |
* | "Translate now" |
*
* @param {Blog_Ai_Translate_Offer_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_translate_offer_action = /** @type {((inputs?: Blog_Ai_Translate_Offer_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Translate_Offer_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_translate_offer_action(inputs)
	return cs_blog_ai_translate_offer_action(inputs)
});